import React from "react";

export type FieldMode = "prefill" | "agent";

interface Props {
  fieldName: string;
  label?: string;
  description?: string;
  mode: FieldMode;
  value: string;
  onModeChange: (mode: FieldMode) => void;
  onValueChange: (value: string) => void;
}

export function FieldToggle({ fieldName, label, description, mode, value, onModeChange, onValueChange }: Props) {
  return (
    <div className="field-toggle-row">
      <div className="field-toggle-header">
        <div>
          <span className="field-toggle-name">{label || fieldName}</span>
          {description && (
            <span style={{ fontSize: "var(--font-size-sm)", color: "var(--indaco-gray-500)", marginLeft: 8 }}>
              {description}
            </span>
          )}
        </div>
        <div className="field-toggle-buttons">
          <button
            type="button"
            className={`field-toggle-btn${mode === "prefill" ? " field-toggle-btn-active" : ""}`}
            onClick={() => onModeChange("prefill")}
            title="Lo compilo io"
          >
            ✏️ Lo compilo io
          </button>
          <button
            type="button"
            className={`field-toggle-btn${mode === "agent" ? " field-toggle-btn-active agent" : ""}`}
            onClick={() => onModeChange("agent")}
            title="Lo chiede l'agente"
          >
            🤖 Lo chiede l'agente
          </button>
        </div>
      </div>

      {mode === "prefill" && (
        <input
          type="text"
          className="form-input"
          placeholder={`Inserisci ${fieldName}`}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
        />
      )}
    </div>
  );
}
